<template>
  <AppLayout>
    <div class="crumb">
      <span class="muted">首页</span>
      <span class="sep">></span>
      <span class="active">发布任务</span>
    </div>
    <div class="page">


      <div class="form-wrap">
        <el-form ref="formRef" class="publish-form" :model="form" :rules="rules" label-position="right"
          label-width="120px" status-icon @submit.prevent>
          <el-form-item label="任务名称" prop="title">
            <el-input v-model="form.title" placeholder="请输入" maxlength="60" clearable />
          </el-form-item>

          <el-form-item label="任务介绍" prop="desc">
            <el-input v-model="form.desc" type="textarea" :rows="4" placeholder="请输入" />
          </el-form-item>

          <el-form-item label="截止时间" prop="deadline">
            <el-date-picker v-model="form.deadline" type="date" placeholder="请选择" format="YYYY-MM-DD"
              value-format="YYYY-MM-DD" style="width: 100%" />
          </el-form-item>

          <el-form-item label="预算" prop="budgetType">
            <div class="budget">
              <el-radio-group v-model="form.budgetType">
                <el-radio value="range">预算区间</el-radio>
                <el-radio value="fixed">指定金额</el-radio>
              </el-radio-group>

              <!-- ✅ 内嵌校验：错误提示显示在输入框下方 -->
              <el-form-item v-if="form.budgetType === 'range'" class="inner-item" prop="budgetRange">
                <div class="budget-inputs">
                  <el-input v-model.number="form.budgetMin" type="number" placeholder="最低预算" />
                  <span class="dash">-</span>
                  <el-input v-model.number="form.budgetMax" type="number" placeholder="最高预算" />
                </div>
              </el-form-item>

              <el-form-item v-else class="inner-item" prop="budgetFixed">
                <div class="budget-inputs">
                  <el-input v-model.number="form.budgetFixed" type="number" placeholder="请输入" />
                </div>
              </el-form-item>
            </div>
          </el-form-item>

          <el-form-item label="参考图片">
            <div class="uploader-wrap">
              <div class="uploader" @dragover.prevent @drop.prevent="onDrop">
                <input ref="fileInput" class="file" type="file" accept="image/*" multiple @change="onPickFiles" />

                <div class="upload-tip" v-if="showimg">
                  <el-button link type="success" @click="pickFiles">点击上传</el-button>
                  <img src="../assets/slash.png" class="slashlogo" alt="" />
                  <span class="muted">拖拽到此区域</span>
                </div>

                <div v-if="images.length" class="thumbs">
                  <div v-for="img in images" :key="img.id" class="thumb">
                    <img :src="img.url" alt="preview" />
                    <el-button class="x" circle type="danger" plain size="small" @click="removeImage(img.id)">
                      ×
                    </el-button>
                  </div>
                </div>
              </div>

              <div class="upload-remark muted">额外提示语，文字过多时宽度折行</div>
            </div>
          </el-form-item>

          <el-form-item label="技能标签" prop="tags">
            <div class="tag-area">
              <div class="selected">
                <el-tag v-for="t in form.tags" :key="t" class="selected-tag" type="success" 
                  @close="removeTag(t)">
                  <span>{{ t }}</span>
                  <img class="ui-prefix" src="@/assets/Outlinex.png" alt="" />
                </el-tag>
              </div>
           
              <div v-if="tagPanelOpen" class="tag-panel">
                <div v-for="(t, i) in allTags" :key="t + '_' + i" class="tag-btn" @click="toggleTag(t)">

                  {{ t }}
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="是否看子任务" prop="showSubtasks">
            <div class="stack">
              <el-radio-group v-model="form.showSubtasks">
                <el-radio :value="true">是</el-radio>
                <el-radio :value="false">否</el-radio>
              </el-radio-group>

              <div v-if="form.showSubtasks" class="subtasks">
                <div v-for="st in form.subtasks" :key="st.id" class="subtask">
                  <div class="subtask-main">
                    <div class="subtask-title">{{ st.title || '子任务标题' }}</div>

                    <div class="subtask-meta-row">
                      <div class="subtask-meta muted">
                        报价：￥{{ st.price || 0 }}&nbsp;&nbsp;截止时间：{{ st.deadline || '未设置' }}
                      </div>

                      <el-button type="danger" text class="trash-btn" @click="removeSubtask(st.id)">
                        <img src="../assets/del.png" class="trash" alt="delete" />
                      </el-button>
                    </div>
                  </div>
                </div>

                <div class="add-subtask" @click="addSubtask">添加</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="是否用于任务" prop="purpose">
            <el-radio-group v-model="form.purpose">
              <el-radio value="personal">个人用途</el-radio>
              <el-radio value="business">商业用途</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="位置要求" prop="locationReq">
            <div class="stack">
              <el-radio-group v-model="form.locationReq">
                <el-radio value="none">无要求</el-radio>
                <el-radio value="need">有要求</el-radio>
              </el-radio-group>

              <!-- ✅ 内嵌校验：错误提示显示在选择器下方 -->
              <el-form-item v-if="form.locationReq === 'need'" class="inner-item" prop="location">
                <div class="location">
                  <el-select v-model="form.location" placeholder="请选择" style="width: 100%">
                    <el-option label="北京" value="北京" />
                    <el-option label="上海" value="上海" />
                    <el-option label="广州" value="广州" />
                    <el-option label="深圳" value="深圳" />
                    <el-option label="杭州" value="杭州" />
                  </el-select>
                </div>
              </el-form-item>
            </div>
          </el-form-item>

          <div class="actions">
            <el-button type="success" class="primary" @click="onSubmit">提交</el-button>
            <el-button @click="onReset">取消</el-button>
          </div>
        </el-form>
      </div>

      <!-- ✅ 发布成功弹窗：样式生效关键点是 :teleported="false" -->
      <el-dialog v-model="successOpen" width="420px" align-center :teleported="false" modal :lock-scroll="true"
        :show-close="false" :close-on-click-modal="true" :close-on-press-escape="true" class="success-dialog">
        <div class="success-body">
          <img class="success-icon" src="../assets/Frame 9800.png" alt="" />

          <div class="success-title">发布任务成功</div>
          <div class="success-desc muted">发布任务成功，等待后台审核</div>

          <div class="success-actions">
            <el-button type="success" class="success-cta" @click="continuePublish">继续发布</el-button>
            <el-button type="success" link @click="goHome">返回首页</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </AppLayout>
</template>

<script setup>
import { onBeforeUnmount, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'

const router = useRouter()

function uid() {
  return Math.random().toString(16).slice(2) + Date.now().toString(16)
}
const showimg = ref(true)
const tagPanelOpen = ref(true)
const successOpen = ref(false)

const formRef = ref(null)
const fileInput = ref(null)

const images = ref([])
const allTags = ref(['标签1', '标签1', '标签1', '标签1', '标签1', '标签1', '标签1', '标签1111', '标签11111', '标签111111'])

const form = reactive({
  title: '',
  desc: '',
  deadline: '',
  budgetType: 'range',
  budgetMin: null,
  budgetMax: null,
  budgetFixed: null,
  tags: ['Axure', 'Sketch', 'XD', 'Figma', '界面设计'],
  showSubtasks: true,
  subtasks: [
    {
      id: uid(),
      title:
        '任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍',
      desc: '任务介绍任务介绍任务介绍任务介绍',
      price: 1200,
      deadline: '2026-01-01',
    },
    {
      id: uid(),
      title:
        '任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍任务介绍',
      desc: '任务介绍任务介绍任务介绍任务介绍',
      price: 1200,
      deadline: '2026-01-01',
    },
  ],
  purpose: 'personal',
  locationReq: 'need',
  location: '',
})

/* ✅ 预算区间校验（挂到 prop=budgetRange） */
function validateBudgetRange(_rule, _value, callback) {
  if (form.budgetType !== 'range') return callback()
  if (form.budgetMin == null || form.budgetMax == null) return callback(new Error('请填写预算区间'))
  if (Number(form.budgetMin) > Number(form.budgetMax)) return callback(new Error('预算最小值不能大于最大值'))
  callback()
}

/* ✅ 指定金额校验（挂到 prop=budgetFixed） */
function validateBudgetFixed(_rule, _value, callback) {
  if (form.budgetType !== 'fixed') return callback()
  if (form.budgetFixed == null || form.budgetFixed === '') return callback(new Error('请填写指定金额'))
  callback()
}

/* ✅ 位置校验（挂到 prop=location） */
function validateLocation(_rule, _value, callback) {
  if (form.locationReq !== 'need') return callback()
  if (!form.location) return callback(new Error('请选择位置'))
  callback()
}

const rules = reactive({
  title: [{ required: true, message: '请填写任务名称', trigger: 'blur' }],
  desc: [{ required: true, message: '请填写任务介绍', trigger: 'blur' }],
  deadline: [{ required: true, message: '请选择截止时间', trigger: 'change' }],

  budgetType: [{ required: true, message: '请选择预算方式', trigger: 'change' }],
  budgetRange: [{ validator: validateBudgetRange, trigger: ['blur', 'change'] }],
  budgetFixed: [{ validator: validateBudgetFixed, trigger: ['blur', 'change'] }],

  tags: [
    {
      validator: (_r, v, cb) => (Array.isArray(v) && v.length ? cb() : cb(new Error('请选择至少一个技能标签'))),
      trigger: 'change',
    },
  ],

  showSubtasks: [{ required: true, message: '请选择是否看子任务', trigger: 'change' }],
  purpose: [{ required: true, message: '请选择用途', trigger: 'change' }],
  locationReq: [{ required: true, message: '请选择位置要求', trigger: 'change' }],
  location: [{ validator: validateLocation, trigger: 'change' }],
})

// function toggleTag(t) {
//   const has = form.tags.includes(t)
//   form.tags = has ? form.tags.filter((x) => x !== t) : [...form.tags, t]
// }
function removeTag(t) {
  form.tags = form.tags.filter((x) => x !== t)
}

function pickFiles() {
  fileInput.value?.click?.()
}
function onPickFiles(e) {
  console.log(11111)
  // showimg.value=false
  const files = Array.from(e.target.files || [])
  addFiles(files)
  e.target.value = ''
}
function onDrop(e) {
  const files = Array.from(e.dataTransfer.files || [])
  addFiles(files)
}
function addFiles(files) {
  const left = Math.max(0, 8 - images.value.length)
  const imgs = files
    .filter((f) => f.type.startsWith('image/'))
    .slice(0, left)
    .map((f) => ({ id: uid(), url: URL.createObjectURL(f), file: f }))

  images.value = [...images.value, ...imgs]
}
function removeImage(id) {
  const target = images.value.find((x) => x.id === id)
  if (target?.url) URL.revokeObjectURL(target.url)
  images.value = images.value.filter((x) => x.id !== id)
}

function addSubtask() {
  form.subtasks = [...form.subtasks, { id: uid(), title: '新子任务', desc: '请填写子任务说明', price: 0, deadline: '' }]
}
function removeSubtask(id) {
  form.subtasks = form.subtasks.filter((x) => x.id !== id)
}

async function onSubmit() {
  if (!formRef.value) return
  try {
    await formRef.value.validate()
    // TODO: 调用发布接口成功后再弹窗
    successOpen.value = true
  } catch {
    // 校验不通过：错误会显示在输入框下方
  }
}

function onReset() {
  formRef.value?.resetFields?.()
  images.value.forEach((x) => x.url && URL.revokeObjectURL(x.url))
  images.value = []
}

function continuePublish() {
  successOpen.value = false
  onReset()
}
function goHome() {
  successOpen.value = false
  router.push('/')
}

onBeforeUnmount(() => {
  images.value.forEach((x) => x.url && URL.revokeObjectURL(x.url))
})
</script>

<style lang="scss" scoped>
.crumb {

  margin: 8px 0 18px;
  font-weight: 400;
  font-size: 14px;
  color: #909399;
  padding-left: clamp(24px, 6vw, 240px);

  .sep {
    margin: 0 8px;
    color: #c7c7c7;
  }

  .active {
    font-weight: 400;
    font-size: 14px;
    color: #69C200;
  }
}

.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 18px 24px 56px;
  background: #fff;

  .muted {
    color: #8a8a8a;
  }



  .form-wrap {
    display: flex;
    justify-content: center;
  }

  .publish-form {
    width: 740px;
    padding: 6px 0 0;
  }

  :deep(.el-form-item) {
    margin-bottom: 18px;
  }

  :deep(.el-form-item__label) {
    text-align: right;
    padding-right: 12px;
    color: #303133;
    font-size: 14px;
    line-height: 34px;
  }

  :deep(.el-form-item__content) {
    line-height: 34px;
    width: 100%;
  }

  /* ✅ 错误提示固定在控件下方 */
  :deep(.el-form-item__error) {
    position: static;
    margin-top: 6px;
    line-height: 1.2;
  }

  /* ✅ 内嵌 form-item：不显示 label，不挤宽度，内容撑满 */
  :deep(.inner-item.el-form-item) {
    margin-bottom: 0;
  }

  :deep(.inner-item .el-form-item__label) {
    display: none;
  }

  :deep(.inner-item .el-form-item__content) {
    margin-left: 0 !important;
    width: 100%;
    line-height: 1.2;
  }

  /* ✅ 表单长度一致关键：stack/location/select 都撑满 */
  .stack {
    width: 100%;
  }

  .location {
    width: 100%;
  }

  :deep(.location .el-select) {
    width: 100%;
  }

  :deep(.el-input__wrapper),
  :deep(.el-textarea__inner),
  :deep(.el-select__wrapper),
  :deep(.el-date-editor .el-input__wrapper) {
    min-height: 34px;
    box-sizing: border-box;
  }

  /* Radio 视觉 */
  :deep(.el-radio) {
    --el-radio-font-size: 14px;
  }

  :deep(.el-radio__inner) {
    width: 14px;
    height: 14px;
    border-width: 2px;
    border-color: #dcdcdc;
  }

  :deep(.el-radio__input.is-checked .el-radio__inner) {
    border-color: #5aa600;
    background: #5aa600;
  }

  :deep(.el-radio__inner::after) {
    width: 6px;
    height: 6px;
    background-color: #fff;
  }

  :deep(.el-radio__input.is-checked + .el-radio__label) {
    color: #303133;
  }

  .budget {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .budget-inputs {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;

      .dash {
        color: #b0b0b0;
        flex: 0 0 auto;
      }

      :deep(.el-input) {
        flex: 1;
      }
    }
  }

  .uploader-wrap {
    width: 100%;
  }

  .uploader {
    width: 100%;
    min-height: 144px;
    overflow: auto;
    padding: 18px 16px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #dcdcdc;

    display: flex;
    flex-direction: column;
    justify-content: center;

    .file {
      display: none;
    }

    .upload-tip {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 13px;

      .slashlogo {
        width: 16px;
        height: 16px;
        flex: 0 0 16px;
      }
    }

    .thumbs {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .thumb {
        width: 88px;
        height: 88px;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        border: 1px solid #e8e8e8;
        background: #fff;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        :deep(.x.el-button) {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 22px;
          height: 22px;
          padding: 0;
          min-height: 22px;
        }
      }
    }
  }

  .upload-remark {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.6;
    white-space: normal;
    word-break: break-word;
  }

  .tag-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .selected {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding-top: 4px;
    align-items: center;

    .elected-tag {}
  }

  .selected-tag {
    height: 40px;
    width: 109px;
    font-size: 16px;
    :deep(.el-tag__content){
      display: flex;
      align-items: center;
    }
    .ui-prefix{
      width: 16px;
      height: 16px;
      margin-left: 10px;
  }
  }
  .tag-panel {
    background: #f7f7f7;
    border-radius: 12px;
    padding: 16px 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .tag-btn {
      width: 82px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 16px;
      color: #616161;
    }
  }

  .subtasks {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .subtask {
      // border: 1px solid #efefef;
      border-radius: 8px;
      padding: 14px;
      background: #F7F7F7;
    }

    .subtask-title {
      font-size: 14px;
      color: #111111;
      margin-bottom: 6px;
      line-height: 1.4;
    }

    .subtask-meta-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      min-width: 0;
    }

    .subtask-meta {
      font-weight: 400;
      font-size: 14px;
      color: #555555;
      line-height: 25px;
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .trash {
      width: 18px;
      height: 18px;
      display: block;
    }

    // :deep(.trash-btn.el-button) {
    //   padding: 0;
    //   height: 18px;
    // }


  }

  .add-subtask {
    width: 100%;
    height: 44px;
    border-radius: 0px 0px 0px 0px;
    border: 1px dashed #4CAF50;
    font-weight: 400;
    font-size: 12px;
    color: #4CAF50;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 10px;

    :deep(.el-button) {
      width: 80px;
      height: 40px;
    }

    :deep(.primary.el-button) {
      background: #4caf50;
      border-color: #4caf50;
      border-radius: 2px;
    }
  }

  /* ✅ 成功弹窗样式（现在会生效） */
  :deep(.success-dialog .el-dialog) {
    border-radius: 8px;
    overflow: hidden;

  }

  :deep(.success-dialog .el-dialog__header) {
    display: none;
  }

  :deep(.success-dialog .el-dialog__body) {
    padding: 28px 28px 22px;
  }

  .success-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .success-icon {
    margin: 6px 0 28px;

    width: 100px;
    height: 100px;

    .ring {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      background: linear-gradient(180deg, #6fe36a 0%, #34b34a 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 10px 22px rgba(46, 160, 67, 0.25);
    }

    .check {
      color: #fff;
      font-size: 44px;
      font-weight: 800;
      line-height: 1;
    }
  }

  .success-title {
    font-weight: 400;
    font-size: 20px;
    color: #2E323E;
    margin-bottom: 6px;
  }

  .success-desc {
    font-weight: 400;
    font-size: 16px;
    color: #9899A2;
    margin-bottom: 48px;
  }

  .success-actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    font-size: 15px;
    color: #91DF35;
  }

  :deep(.success-cta.el-button) {
    width: 260px;
    height: 41px;
    background: linear-gradient(39deg, #4CAF50 0%, #91DF35 100%);
    box-shadow: 2px 2px 4px 0px rgba(24, 144, 255, 0.1);
    border-radius: 200px 200px 200px 200px;
    margin-bottom: 45px;
  }

  @media (max-width: 860px) {
    padding: 14px 14px 44px;

    .publish-form {
      width: 100%;
    }

    :deep(.el-form-item) {
      display: block;
    }

    :deep(.el-form-item__label) {
      width: auto !important;
      padding-right: 0;
      text-align: left;
      display: block;
      margin-bottom: 6px;
      line-height: 1.4;
    }

    :deep(.el-form-item__content) {
      margin-left: 0 !important;
    }
  }
}
</style>